import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RoleDto } from 'projects/shared/src/lib/models/SquirrelRoles';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { ProjectRolesService } from 'projects/shared/src/lib/services/project-roles.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';


@Component({
  selector: 'group-role-delete-dialog',
  templateUrl: './group-role-delete-dialog.component.html',
  styleUrls: ['./group-role-delete-dialog.component.scss']
})
export class GroupRoleDeleteDialogComponent implements OnInit {

  groupRoleForm!: FormGroup;
  roleDto!: RoleDto;
  _db!:string;

  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<GroupRoleDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private projectRolesService: ProjectRolesService,
    private tenantService:TenantService,
    private oauthService: OAuthServiceService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    console.log("------> delete-group-role-dialog data: ", this.data);
    // console.log("------> delete-group-role-dialog name: ", this.data.rowData.name);
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin') {
             this._db = dbrole;
            }
          });
        }
      }
    });
    this.createGroupRoleForm();
  }

  createGroupRoleForm(){
    this.groupRoleForm = this.fb.group({
      groupRoleId:[this.data.id],
      projectId:[this.data.projectId],
      name:[this.data.name]
    });
  }

  deleteGroupRole(id: string){

    if(this.groupRoleForm.valid){
      let db:string = this.tenantService.currentTenantName;
      if(this.data.projectId != null){
        this.tenantService.deleteRole(db, id).subscribe({
          next:(data) => {
            console.log(data);
            this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTUSERGROUPROLEDELETED"]}`);
          },
          error: error => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["DELETEPROJECTUSERGROUPROLEERROR"]}`)
        });
      } else{
        this.tenantService.deleteRoleTemplate(db, id).subscribe({
          next:(data) => {
            console.log(data);
            this.notificationService.success(`${this.translate.data["SUCCESS"]}`, "Vorlage gelöscht");
          },
          error: error => this.notificationService.error(`${this.translate.data["ERROR"]}`, "Vorlage konnte nicht gelöscht werden")
        });
      }
      this.dialogRef.close(this.groupRoleForm.value);
    }
  }

  deleteFromMaindb(id: string) {
    if(this.groupRoleForm.valid){
      this.projectRolesService.deleteRole(id).subscribe({
        next:(data) => {
          console.log(data);
          this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTUSERGROUPROLEDELETED"]}`);
        },
        error: error => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["DELETEPROJECTUSERGROUPROLEERROR"]}`)
      });
      this.dialogRef.close(this.groupRoleForm.value);
    }
  }

  cancel() {
    this.dialogRef.close(this.groupRoleForm.value);
  }
}
